"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSearchTrackingEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a track search term
 * Event name: "web:search:story::search"
 */
var sendSearchTrackingEvent = function (eventInfo) {
    (0, _1.sendEvent)("search", "story", null, "search", eventInfo);
};
exports.sendSearchTrackingEvent = sendSearchTrackingEvent;
